;(function () {
  'use strict'

  const CMP_FORM_TEXT = 'cmp-form-text'
  const CMP_FORM_OPTIONS = 'cmp-form-options'

  const classByType = {
    textarea: CMP_FORM_TEXT,
    'select-one': CMP_FORM_OPTIONS,
    text: CMP_FORM_TEXT,
    email: CMP_FORM_TEXT,
    tel: CMP_FORM_TEXT,
    checkbox: CMP_FORM_OPTIONS,
    radio: CMP_FORM_OPTIONS,
  }

  function applyRequiredMessage(element) {
    element.setCustomValidity('')

    if (element.validity.valueMissing && element.dataset.requiredMessage) {
      element.setCustomValidity(element.dataset.requiredMessage)
    }

    const describedById = element.getAttribute('aria-describedby')
    const errorMessageElement = describedById && document.getElementById(describedById)

    if (errorMessageElement) {
      errorMessageElement.textContent = element.validationMessage
    }
  }

  function getFieldContainer(element) {
    return element.closest(`.${CMP_FORM_TEXT}, .${CMP_FORM_OPTIONS}`)
  }

  function parseFileDataTables(formDataTable) {
    const formDataTableObject = {}

    formDataTable?.forEach((table) => {
      const inputs = table.querySelectorAll('input:not([type="hidden"])')
      const formDataTableLabelInput = table.querySelector('input[type="hidden"][name$="_label"]')

      inputs.forEach((input) => {
        input.value = input.value.trim()

        const [name, row, header] = input.name.split('_')

        if (!formDataTableObject[name]) {
          formDataTableObject[name] = {}
        }

        if (!formDataTableObject[name][row]) {
          formDataTableObject[name][row] = {}
        }

        formDataTableObject[name][row][header] = input.value

        if (!formDataTableObject[name].name) {
          formDataTableObject[name].name = name
        }

        if (formDataTableLabelInput) {
          formDataTableObject[name].label = formDataTableLabelInput.value
        }

        if (!formDataTableObject[name].type) {
          formDataTableObject[name].type = 'table'
        }
      })
    })

    return formDataTableObject
  }

  function removeTableEntriesFromFormDataTable(form, formDataTableNames) {
    formDataTableNames?.forEach((name) => {
      const entriesToBeDeleted = form.querySelectorAll('input[name^="' + name + '_"]')

      entriesToBeDeleted?.forEach((entry) => {
        entry.remove()
      })
    })
  }

  function addHiddenInputFormDataTable(form, formDataTablesObject) {
    const formDataTableHiddenInput = document.createElement('input')
    formDataTableHiddenInput.type = 'hidden'
    formDataTableHiddenInput.name = 'formDataTables'
    formDataTableHiddenInput.value = JSON.stringify(formDataTablesObject)
    form.appendChild(formDataTableHiddenInput)
  }

  function buildFormDataTables(formDataTable, form) {
    const formDataTablesObject = parseFileDataTables(formDataTable)
    sessionStorage.setItem('formDataTables', JSON.stringify(formDataTablesObject))

    const formDataTableNames = Object.keys(formDataTablesObject)
    removeTableEntriesFromFormDataTable(form, formDataTableNames)
    addHiddenInputFormDataTable(form, formDataTablesObject)
  }

  function onDocumentReady() {
    const form = document.getElementById('contact_form')

    if (!form) {
      return
    }

    const fileDataTable = form.querySelectorAll('[data-component="FormDataTable"]')

    const formElements = form.querySelectorAll('[name]')
    const submitButton = form.querySelector('button[type=submit]')

    if (!submitButton) {
      return
    }

    submitButton.addEventListener('click', function (e) {
      e.preventDefault()
      e.stopPropagation()

      formElements.forEach(applyRequiredMessage)

      if (!form.checkValidity()) {
        // Fieldsets also match :invalid whenever a descendant control is invalid, and since a
        // fieldset precedes its own children in document order, a plain ':invalid' query can
        // match the (unfocusable) fieldset instead of the actual control. Scope to real controls.
        const firstInvalidField = form.querySelector('input:invalid, select:invalid, textarea:invalid')
        if (firstInvalidField) {
          firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' })
          firstInvalidField.focus({ preventScroll: true })
        }
        return
      }

      if (fileDataTable.length > 0) {
        buildFormDataTables(fileDataTable, form)
      }

      form.requestSubmit()
    })

    formElements?.forEach((element) => {
      const elementType = element.type.toLowerCase()
      const elementParent = getFieldContainer(element)

      element.addEventListener(
        'invalid',
        (e) => {
          e.preventDefault()
          e.stopPropagation()
          applyRequiredMessage(element)
          element.setAttribute('aria-invalid', 'true')
          elementParent.classList.add(`${classByType[elementType]}--is-invalid`)
        },
        false,
      )

      element.addEventListener(
        'change',
        (e) => {
          e.preventDefault()
          e.stopPropagation()
          applyRequiredMessage(element)
          elementParent.classList.add(`${classByType[elementType]}--is-interacted`)
          const isValid = element.checkValidity()
          elementParent.classList[isValid ? 'remove' : 'add'](`${classByType[elementType]}--is-invalid`)
          if (isValid) {
            element.removeAttribute('aria-invalid')
          } else {
            element.setAttribute('aria-invalid', 'true')
          }
        },
        false,
      )
    })
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
